import DeleteItemModal from './DeleteItemModal';

export default DeleteItemModal;
